import { render } from "./SignUpBackground.vue?vue&type=template&id=7731228a&ts=true"
import script from "./SignUpBackground.vue?vue&type=script&lang=ts"
export * from "./SignUpBackground.vue?vue&type=script&lang=ts"

import "@/styles/login-screen.css?vue&type=style&index=0&lang=css"

import exportComponent from "/root/source/core/frontend/affiliate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QMenu,QList,QItem,QItemSection});qInstall(script, 'directives', {ClosePopup});
